import React from 'react';
import { Pane } from 'evergreen-ui';
import { Sidebar } from 'Shared/Sidebar/Sidebar';
import L from 'leaflet';
import Map from 'Features/Map/Map';
import MapSidebar from 'Features/Map/MapSidebar';
import StationsFilterFull from 'Features/Filters/StationFilterFull';
import './Home.css'; // TODO: разобрать стили, а то там каша какая-то
import useSidebar from 'Shared/Sidebar/useSidebar';

function Home() {
  const { isPinned, isHide, onChangeHide, onChangePinned } = useSidebar();
  const [map, setMap] = React.useState<L.Map | null>(null);

  const whenMapCreated = React.useCallback((mapInstance: L.Map) => {
    setMap(mapInstance);
  }, []);

  return (
    <Pane display="grid" gridTemplateRows="max-content 1fr">
      <StationsFilterFull />
      <Pane display="grid" gridTemplateColumns="max-content 1fr" position="relative" border>
        <Sidebar
          isHide={isHide}
          isPinned={isPinned}
          onClickHide={onChangeHide}
          onClickPin={onChangePinned}
          title="Карта"
        >
          <MapSidebar mapInstance={map} />
        </Sidebar>
        <Map whenMapCreated={whenMapCreated} />
      </Pane>
    </Pane>
  );
}

export default Home;
